// import React from 'react';
// import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
// import Navbar from './components/Navbar';
// import Footer from './components/Layout/Footer';
// import Checkout from './pages/Checkout';
// import Home from './pages/Home';
// import ProgramDetails from './pages/ProgramDetails';
// import NavbarPageViewer from './pages/NavbarPageViewer';
// import DashboardAdmin from './pages/DashboardAdmin';
// import StudentRoute from './pages/auth/StudentRoute';
// import { ProgramProvider, usePrograms } from './context/ProgramContext';
// import Login from './pages/auth/Login';
// import AdminLogin from './pages/auth/AdminLogin';
// import Register from './pages/auth/Register';
// import ForgotPassword from './pages/auth/ForgotPassword';
// import CategoryPage from './pages/CategoryPage';
// // import DynamicPage from './pages/DynamicPage'; // Removed to avoid route duplication
// import SimulationView from './components/simulation/SimulationView';
// import StudentDashboard from './pages/StudentDashboard';
// import AdminRoute from './pages/auth/AdminRoute';
// import PaymentSuccess from './pages/PaymentSuccess';

// // Easy English: Import the new Coming Soon design component
// import MidanComingSoon from './components/idanComingSoon';

// const SHOW_COMING_SOON = true;

// // Layout for pages that should show the Navbar and Footer
// const MainLayout = () => {
//   return (
//     <>
//       <Navbar />
//       <main className="flex-grow">
//         <Outlet />
//       </main>
//       <Footer />
//     </>
//   );
// };

// // Easy English: Wrapper component to wait for data before showing routes
// const AppContent = () => {
//   const { isFetchingData } = usePrograms();

//   // Easy English: Show loading screen to prevent 404 errors on refresh
//   if (isFetchingData) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-slate-10 dark:bg-slate-500">
//         <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
//       </div>
//     );
//   }

//   return (
//     <Routes>
//       {/* Dashboard and Auth pages without main Navbar */}
//       <Route
//         path="/admin/*"
//         element={
//           <AdminRoute>
//             <DashboardAdmin />
//           </AdminRoute>
//         }
//       />
//       <Route path="/admin-login" element={<AdminLogin />} />
//       <Route path="/login" element={<Login />} />
//       <Route path="/ForgotPassword" element={<ForgotPassword />} />
//       <Route path="/register" element={<Register />} />
//       {/* <Route path="/forgot-password" element={<ForgotPassword />} /> */}
//       <Route path="/simulation/:programId" element={<SimulationView />} />

//       {/* Website pages with fixed Navbar */}
//       <Route element={<MainLayout />}>
//         <Route path="/" element={<Home />} />
//         <Route path="/program/:id" element={<ProgramDetails />} />
//         <Route path="/page/:slug" element={<NavbarPageViewer />} />

//         <Route path="/student" element={
//           <StudentRoute>
//             <StudentDashboard />
//           </StudentRoute>
//         } />
//         <Route path="/category/:id" element={<CategoryPage />} />

//         {/* 👈 المسار الجديد لاستقبال العميل بعد الدفع */}
//         <Route path="/payment-success" element={<PaymentSuccess />} />

//       </Route>
//     </Routes>
//   );
// };

// function App() {
//   if (SHOW_COMING_SOON) {
//     return <MidanComingSoon />;
//   }

//   // Temporary lock note: old database routes are kept below for quick restore.
//   return (
//     <ProgramProvider>
//       <Router>
//         <AppContent />
//       </Router>
//     </ProgramProvider>
//   );
// }

// export default App;
import MidanComingSoon from './components/idanComingSoon';

function App() {
  return <MidanComingSoon />;
}

export default App;